(function () {
  var BUILTIN_STORES = [
  {
    "id": "loc_4n7vmv53",
    "name": "BABY WORLD OF STONEY CREEK",
    "address1": "410 Lewis Road",
    "address2": "Unit #13",
    "city": "Stoney Creek",
    "state": "Ontario",
    "postal": "L8E5Y7",
    "country": "Canada",
    "phone": "905-643-0147",
    "website": "",
    "email": "",
    "logo": "",
    "collections": "",
    "signature": false,
    "lat": 43.219739,
    "lng": -79.656035
  },
  {
    "id": "loc_48xrer64",
    "name": "KIDS-N-CRIBS",
    "address1": "1741 CONTRA COSTA BLVD",
    "address2": "",
    "city": "PLEASANT HILL",
    "state": "California",
    "postal": "94523",
    "country": "United States",
    "phone": "925-778-2229",
    "website": "",
    "email": "",
    "logo": "",
    "collections": "",
    "signature": false,
    "lat": 37.95240016,
    "lng": -122.0602908
  },
  {
    "id": "loc_3rywzwq4",
    "name": "DESTINATION BABY & KIDS",
    "address1": "7054 Village Parkway",
    "address2": "",
    "city": "Dublin",
    "state": "California",
    "postal": "94568",
    "country": "United States",
    "phone": "925-479-9599",
    "website": "",
    "email": "",
    "logo": "https://rlfiles1.azureedge.net/5811da22-67b2-4100-8869-b6c91b194c4a/c84f3b5f-b15e-4ba0-a671-23b6030af6a1/logo.png",
    "collections": "",
    "signature": false,
    "lat": 37.70864101,
    "lng": -121.92600978
  },
  {
    "id": "loc_3v8j9jm3",
    "name": "JUVENILE SHOP",
    "address1": "13356 Ventura Blvd",
    "address2": "",
    "city": "Sherman Oaks",
    "state": "California",
    "postal": "91423",
    "country": "United States",
    "phone": "818-986-6214",
    "website": "",
    "email": "",
    "logo": "https://juvenileshop.com/cdn/shop/files/juvenile-shop-logo_240x.png?v=1613532704",
    "collections": "",
    "signature": false,
    "lat": 34.146567,
    "lng": -118.424412
  },
  {
    "id": "loc_4z5jpjw3",
    "name": "CRIB & KIDS",
    "address1": "1309 N. Loop 1604 W.",
    "address2": "#106",
    "city": "San Antonio",
    "state": "Texas",
    "postal": "78258",
    "country": "United States",
    "phone": "210-764-2742",
    "website": "",
    "email": "",
    "logo": "https://cribandkids.com/cdn/shop/files/Crib_Kids_Logo_2012A_2C.2.jpg?v=1613692719&width=1200",
    "collections": "",
    "signature": false,
    "lat": 29.610531,
    "lng": -98.5129695
  },
  {
    "id": "loc_48pn5z76",
    "name": "ENLIGHTENED BABY",
    "address1": "515 S Congress Ave",
    "address2": "Unit 103",
    "city": "Austin",
    "state": "Texas",
    "postal": "78704",
    "country": "United States",
    "phone": "(512) 766-2852",
    "website": "",
    "email": "",
    "logo": "",
    "collections": "",
    "signature": false,
    "lat": 30.25591902,
    "lng": -97.74669602
  },
  {
    "id": "loc_39zxrey4",
    "name": "BABY'S & KID'S 1ST FURNITURE",
    "address1": "2150 Lone Star Drive",
    "address2": "",
    "city": "Sugar Land",
    "state": "Texas",
    "postal": "77479",
    "country": "United States",
    "phone": "281-277-9600",
    "website": "",
    "email": "",
    "logo": "https://babys1st.com/cdn/shop/files/babys-1st-logo_b7427449-242e-4291-9876-4ec90b289feb_100x.png?v=1666012124",
    "collections": "",
    "signature": false,
    "lat": 29.59530761,
    "lng": -95.62394306
  },
  {
    "id": "loc_47mr2nq4",
    "name": "BABY'S & KID'S 1ST FURNITURE",
    "address1": "5575 Richmond",
    "address2": "",
    "city": "Houston",
    "state": "Texas",
    "postal": "77056",
    "country": "United States",
    "phone": "713-785-8511",
    "website": "",
    "email": "",
    "logo": "https://babys1st.com/cdn/shop/files/babys-1st-logo_b7427449-242e-4291-9876-4ec90b289feb_100x.png?v=1666012124",
    "collections": "",
    "signature": true,
    "lat": 29.73138027,
    "lng": -95.47584637
  },
  {
    "id": "loc_3jrne9e3",
    "name": "BABY GRAND",
    "address1": "4200 MINNETONKA BLVD",
    "address2": "",
    "city": "St. Louis Park",
    "state": "Minnesota",
    "postal": "55416",
    "country": "United States",
    "phone": "952-912-1010",
    "website": "",
    "email": "",
    "logo": "https://babyongrand.com/cdn/shop/files/BabyGrandLOGO_black-2.jpg?v=1692124935&width=200",
    "collections": "",
    "signature": false,
    "lat": 44.948862,
    "lng": -93.332988
  },
  {
    "id": "loc_465knk53",
    "name": "LULLABYE SHOP",
    "address1": "2144 West Wisconsin Ave.",
    "address2": "",
    "city": "Appleton",
    "state": "Wisconsin",
    "postal": "54914",
    "country": "United States",
    "phone": "(920) 734-9332",
    "website": "",
    "email": "",
    "logo": "",
    "collections": "",
    "signature": false,
    "lat": 44.273574,
    "lng": -88.440588
  },
  {
    "id": "loc_3xjxqq63",
    "name": "DREAM A LITTLE DREAM",
    "address1": "9981 W. 190TH STREET",
    "address2": "SUITE F",
    "city": "MOKENA",
    "state": "Illinois",
    "postal": "60448",
    "country": "United States",
    "phone": "708-995-7035",
    "website": "",
    "email": "",
    "logo": "",
    "collections": "",
    "signature": false,
    "lat": 41.54426099,
    "lng": -87.86014299
  },
  {
    "id": "loc_4z5jppw3",
    "name": "GALT BABY & TOYS",
    "address1": "1310 Northbrook Court",
    "address2": "",
    "city": "Northbrook",
    "state": "Illinois",
    "postal": "60062",
    "country": "United States",
    "phone": "847-509-8800",
    "website": "",
    "email": "",
    "logo": "",
    "collections": "",
    "signature": false,
    "lat": 42.15193679,
    "lng": -87.81724943
  },
  {
    "id": "loc_4n7vmm53",
    "name": "TWINKLE TWINKLE LITTLE ONE",
    "address1": "461 CENTRAL AVENUE",
    "address2": "",
    "city": "HIGHLAND PARK",
    "state": "ILLINOIS",
    "postal": "60035",
    "country": "United States",
    "phone": "847-926-3120",
    "website": "",
    "email": "",
    "logo": "https://twinkletwinklelittleone.com/cdn/shop/files/White_Round_Background.png?v=1704987321&width=170",
    "collections": "",
    "signature": false,
    "lat": 42.1866027,
    "lng": -87.7974761
  },
  {
    "id": "loc_39zxrjy4",
    "name": "TWINKLE TWINKLE LITTLE ONE",
    "address1": "2007 W. Belmont Ave",
    "address2": "",
    "city": "Chicago",
    "state": "Illinois",
    "postal": "60618",
    "country": "United States",
    "phone": "773-472-3000",
    "website": "",
    "email": "",
    "logo": "https://twinkletwinklelittleone.com/cdn/shop/files/White_Round_Background.png?v=1704987321&width=170",
    "collections": "",
    "signature": false,
    "lat": 41.939388,
    "lng": -87.678621
  },
  {
    "id": "loc_3mr9xyv4",
    "name": "DECOR 4 KIDS",
    "address1": "17728 Sun Park Drive",
    "address2": "",
    "city": "Westfield",
    "state": "Indiana",
    "postal": "46074",
    "country": "United States",
    "phone": "317-770-7700",
    "website": "http://www.decor4kidsstore.com",
    "email": "",
    "logo": "",
    "collections": "",
    "signature": false,
    "lat": 40.045482,
    "lng": -86.1403545
  },
  {
    "id": "loc_3qk8xnxy",
    "name": "KIDDIE KASTLE FURNITURE",
    "address1": "215 S Hurstbourne Pkwy",
    "address2": "",
    "city": "Louisville",
    "state": "Kentucky",
    "postal": "40222",
    "country": "usa",
    "phone": "(502) 895-1648",
    "website": "",
    "email": "",
    "logo": "",
    "collections": "",
    "signature": false,
    "lat": 38.2426357,
    "lng": -85.5763715
  },
  {
    "id": "loc_4yv6wqwv",
    "name": "MOLLY MONKEY FURNITURE",
    "address1": "11809 Shelbyville Rd",
    "address2": "",
    "city": "Louisville",
    "state": "Kentucky",
    "postal": "40243",
    "country": "USA",
    "phone": "(502) 434-7700",
    "website": "",
    "email": "",
    "logo": "",
    "collections": "",
    "signature": false,
    "lat": 38.2479263,
    "lng": -85.5376646
  },
  {
    "id": "loc_rxkwrwmq",
    "name": "CUDDLES & CARRIAGES",
    "address1": "400 Town Park Blvd",
    "address2": "",
    "city": "Evans",
    "state": "GA",
    "postal": "30809",
    "country": "USA",
    "phone": "(706) 829-4999",
    "website": "",
    "email": "",
    "logo": "",
    "collections": "",
    "signature": false,
    "lat": 33.5287865,
    "lng": -82.13319717
  },
  {
    "id": "loc_4pvymyk4",
    "name": "BERG'S BABY & TEEN FURNITURE",
    "address1": "5694 Mayfield Road",
    "address2": "",
    "city": "Lyndhurst",
    "state": "Ohio",
    "postal": "44124",
    "country": "United states",
    "phone": "440-442-2229",
    "website": "",
    "email": "",
    "logo": "",
    "collections": "",
    "signature": true,
    "lat": 41.51993649,
    "lng": -81.47503803
  },
  {
    "id": "loc_4582w2n3",
    "name": "BABY FURNITURE PLUS KIDS",
    "address1": "116 Decker Park Road",
    "address2": "",
    "city": "Columbia",
    "state": "South Carolina",
    "postal": "29206",
    "country": "United States",
    "phone": "803-788-5880",
    "website": "",
    "email": "",
    "logo": "",
    "collections": "",
    "signature": false,
    "lat": 34.056396,
    "lng": -80.9478405
  },
  {
    "id": "loc_4we8vpx4",
    "name": "COZY KIDS - PINEVILLE",
    "address1": "11523-A Carolina Place Pkwy.",
    "address2": "",
    "city": "Pineville",
    "state": "North Carolina",
    "postal": "28134",
    "country": "United States",
    "phone": "704-540-3716",
    "website": "",
    "email": "",
    "logo": "",
    "collections": "",
    "signature": true,
    "lat": 35.075727,
    "lng": -80.8777935
  },
  {
    "id": "loc_4z5jpmw3",
    "name": "SHOWER ME WITH LOVE",
    "address1": "4845 Ashley Park Ln",
    "address2": "",
    "city": "Charlotte",
    "state": "Nort Carolina",
    "postal": "28210",
    "country": "United States",
    "phone": "919-851-4000",
    "website": "",
    "email": "",
    "logo": "",
    "collections": "",
    "signature": false,
    "lat": 35.14627605,
    "lng": -80.83150663
  },
  {
    "id": "loc_3rywz5q4",
    "name": "ROLLY'S BABY BOUTIQUE",
    "address1": "1208 BARKSDALE RD",
    "address2": "",
    "city": "LEWISVILLE",
    "state": "North Carolina",
    "postal": "27023",
    "country": "United States",
    "phone": "336-722-6713",
    "website": "",
    "email": "",
    "logo": "",
    "collections": "",
    "signature": false,
    "lat": 36.09158536,
    "lng": -80.28174849
  },
  {
    "id": "loc_4kr2m5q3",
    "name": "ALL ABOUT KIDS FURNITURE",
    "address1": "1420 Washington Rd",
    "address2": "",
    "city": "Washington",
    "state": "Pennsylvania",
    "postal": "15301",
    "country": "United States",
    "phone": "724-916-4230",
    "website": "",
    "email": "",
    "logo": "https://allaboutkidsfurniture.com/cdn/shop/files/logo_175x.png?v=1613577171",
    "collections": "",
    "signature": false,
    "lat": 40.212891,
    "lng": -80.194752
  },
  {
    "id": "loc_4ygryyv4",
    "name": "BELLINI - BOCA RATON",
    "address1": "2980 N FEDERAL HWY # 2",
    "address2": "",
    "city": "BOCA RATON",
    "state": "Florida",
    "postal": "33431",
    "country": "United States",
    "phone": "561-392-7444",
    "website": "",
    "email": "",
    "logo": "",
    "collections": "New York, Dakota, Ventianni, Cleopatra, Imperio, Karisma",
    "signature": true,
    "lat": 26.378289,
    "lng": -80.075898
  },
  {
    "id": "loc_3mr9x9v4",
    "name": "BABY BLOOMERS",
    "address1": "642 Coleman Blvd",
    "address2": "",
    "city": "Mt. Pleasant",
    "state": "South Carolina",
    "postal": "29464",
    "country": "United States",
    "phone": "843-856-9277",
    "website": "",
    "email": "",
    "logo": "",
    "collections": "",
    "signature": false,
    "lat": 32.79115661,
    "lng": -79.87382929
  },
  {
    "id": "loc_3ervyjv4",
    "name": "THE KANGAROO POUCH",
    "address1": "4025 N Kings Hwy",
    "address2": "#12",
    "city": "Myrtle Beach",
    "state": "South Carolina",
    "postal": "29577",
    "country": "United States",
    "phone": "843-839-0990",
    "website": "",
    "email": "",
    "logo": "",
    "collections": "",
    "signature": false,
    "lat": 33.71729129,
    "lng": -78.85426549
  },
  {
    "id": "loc_3xjxqx63",
    "name": "TOTS TO TEENS FURNITURE",
    "address1": "8732 Glenwood Avenue",
    "address2": "",
    "city": "Raleigh",
    "state": "North Carolina",
    "postal": "27617",
    "country": "United States",
    "phone": "919-420-0005",
    "website": "",
    "email": "",
    "logo": "",
    "collections": "",
    "signature": false,
    "lat": 35.889444,
    "lng": -78.746112
  },
  {
    "id": "loc_4ygry7v4",
    "name": "THE VELVETEEN RABBIT",
    "address1": "1200 Bridgeport Way Suite 103",
    "address2": "#103",
    "city": "Suffolk",
    "state": "Virginia",
    "postal": "23435",
    "country": "United States",
    "phone": "757-483-0750",
    "website": "",
    "email": "",
    "logo": "",
    "collections": "",
    "signature": false,
    "lat": 36.863638,
    "lng": -76.460547
  },
  {
    "id": "loc_47mr2rq4",
    "name": "KIDS 'N KRIBS",
    "address1": "111 Lancaster Ave",
    "address2": "Suite A",
    "city": "Devon",
    "state": "Pennsylvania",
    "postal": "19333",
    "country": "United States",
    "phone": "610-687-5437",
    "website": "",
    "email": "",
    "logo": "https://kidsnkribs.com/cdn/shop/files/KidsNKribs_Color1_TM.png?v=1714766739",
    "collections": "",
    "signature": false,
    "lat": 40.044771,
    "lng": -75.38805
  },
  {
    "id": "loc_39zxrxy4",
    "name": "KIDS BEDROOM GALLERIES",
    "address1": "282 ROUTE 18",
    "address2": "",
    "city": "East Brunswick",
    "state": "New Jersey",
    "postal": "08816",
    "country": "United States",
    "phone": "(732) 210-4811",
    "website": "",
    "email": "",
    "logo": "https://kidsbedroomgallery.com/cdn/shop/files/kids-bedroom-gallery-logo.jpg?v=1678923656&width=1200",
    "collections": "",
    "signature": true,
    "lat": 40.458969,
    "lng": -74.401128
  },
  {
    "id": "loc_3qqpmpy3",
    "name": "LAKELAND BABY & TEEN FURNITURE",
    "address1": "770 Holy Cross Way",
    "address2": "",
    "city": "Wayne",
    "state": "New Jersey",
    "postal": "07470",
    "country": "United States",
    "phone": "973-694-0007",
    "website": "",
    "email": "",
    "logo": "",
    "collections": "",
    "signature": true,
    "lat": 40.90981498,
    "lng": -74.26122841
  },
  {
    "id": "loc_3xjxqn63",
    "name": "PICCOLINO BABY",
    "address1": "1797 Ave of the States",
    "address2": "",
    "city": "Lakewood",
    "state": "New Jersey",
    "postal": "08701",
    "country": "United States",
    "phone": "732-905-0400",
    "website": "",
    "email": "",
    "logo": "",
    "collections": "",
    "signature": true,
    "lat": 40.089699,
    "lng": -74.2147515
  },
  {
    "id": "loc_3v8j99m3",
    "name": "BAMBI BABY - MIDDLETOWN",
    "address1": "1111 NJ-35",
    "address2": "",
    "city": "MIDDLETOWN",
    "state": "New Jersey",
    "postal": "07748",
    "country": "United States",
    "phone": "877-882-2624",
    "website": "",
    "email": "",
    "logo": "",
    "collections": "",
    "signature": true,
    "lat": 40.39755483,
    "lng": -74.11053719
  },
  {
    "id": "loc_39zxrry4",
    "name": "BAMBI BABY - PARAMUS",
    "address1": "491 RT-17",
    "address2": "",
    "city": "PARAMUS",
    "state": "New Jersey",
    "postal": "07652",
    "country": "United States",
    "phone": "877-882-2624",
    "website": "",
    "email": "",
    "logo": "",
    "collections": "",
    "signature": true,
    "lat": 40.95432749,
    "lng": -74.07339906
  },
  {
    "id": "loc_3vxxen8m",
    "name": "ROOMS BY ZOYA",
    "address1": "200 Lexington Ave",
    "address2": "New York Design Center",
    "city": "New York",
    "state": "New York",
    "postal": "10016",
    "country": "United States",
    "phone": "(212) 726-0006",
    "website": "",
    "email": "",
    "logo": "",
    "collections": "",
    "signature": false,
    "lat": 40.745476,
    "lng": -73.980552
  },
  {
    "id": "loc_3x96gv86",
    "name": "BABY CENTRAL",
    "address1": "2436 McDonald Ave",
    "address2": "",
    "city": "Brooklyn",
    "state": "New York",
    "postal": "11223",
    "country": "USA",
    "phone": "(718) 372-2229",
    "website": "",
    "email": "",
    "logo": "",
    "collections": "",
    "signature": false,
    "lat": 40.59282836,
    "lng": -73.97400125
  },
  {
    "id": "loc_4wzzx2ex",
    "name": "ALBEE BABY",
    "address1": "715 Amsterdam Ave",
    "address2": "",
    "city": "New York",
    "state": "New York",
    "postal": "10025",
    "country": "United States",
    "phone": "(212) 662-7337",
    "website": "",
    "email": "",
    "logo": "",
    "collections": "ALL COLLECTIONS",
    "signature": false,
    "lat": 40.79304118,
    "lng": -73.97082224
  },
  {
    "id": "loc_4kr2mmq3",
    "name": "THE BABY SPRINKLE dba O! BABY",
    "address1": "1493 Coney Island Ave",
    "address2": "",
    "city": "Brooklyn",
    "state": "New York",
    "postal": "11230",
    "country": "United States",
    "phone": "718-998-7373",
    "website": "",
    "email": "",
    "logo": "",
    "collections": "",
    "signature": false,
    "lat": 40.62117,
    "lng": -73.96428997
  },
  {
    "id": "loc_465kny53",
    "name": "WESTCHESTER KIDS & CRIBS",
    "address1": "183 S. Central Avenue",
    "address2": "",
    "city": "Hartsdale",
    "state": "New York",
    "postal": "10530",
    "country": "united States",
    "phone": "914-303-3509",
    "website": "",
    "email": "",
    "logo": "",
    "collections": "",
    "signature": true,
    "lat": 41.014584,
    "lng": -73.804329
  },
  {
    "id": "loc_46r7j8j5",
    "name": "PETIT PRAM",
    "address1": "516 Central Ave",
    "address2": "",
    "city": "Cedarhurst",
    "state": "New York",
    "postal": "11516",
    "country": "USA",
    "phone": "(516) 295-8801",
    "website": "",
    "email": "",
    "logo": "",
    "collections": "",
    "signature": false,
    "lat": 40.6220813,
    "lng": -73.723651
  },
  {
    "id": "loc_4582wyn3",
    "name": "BAMBI BABY - LONG ISLAND",
    "address1": "516 Walt Whitman Road",
    "address2": "",
    "city": "Melville",
    "state": "New York",
    "postal": "11747",
    "country": "United States",
    "phone": "877-882-2624",
    "website": "",
    "email": "",
    "logo": "",
    "collections": "",
    "signature": true,
    "lat": 40.811688,
    "lng": -73.4090895
  },
  {
    "id": "loc_3v8j9pm3",
    "name": "CHAPIN BABY",
    "address1": "1651 RIVERDALE Street",
    "address2": "",
    "city": "West Springfield",
    "state": "Massachusetts",
    "postal": "01089",
    "country": "United States",
    "phone": "413-732-4154",
    "website": "",
    "email": "",
    "logo": "https://www.chapinbaby.com/cdn/shop/files/chapin-baby-logo3.png?v=1614288754&width=250",
    "collections": "",
    "signature": true,
    "lat": 42.149088,
    "lng": -72.6312285
  },
  {
    "id": "loc_47mr2wq4",
    "name": "BELLINI BABY & TEEN",
    "address1": "368 HILLSIDE AVE",
    "address2": "",
    "city": "NEEDHAM",
    "state": "Massachusetts",
    "postal": "02494",
    "country": "United States",
    "phone": "339-777-5489",
    "website": "",
    "email": "",
    "logo": "",
    "collections": "",
    "signature": false,
    "lat": 42.28032464,
    "lng": -71.23763003
  },
  {
    "id": "loc_3jrnene3",
    "name": "BABY BOUDOIR",
    "address1": "1902 Acushnet Avenue",
    "address2": "",
    "city": "New Bedford",
    "state": "Massachusetts",
    "postal": "02745",
    "country": "United States",
    "phone": "508-998-2166",
    "website": "",
    "email": "",
    "logo": "",
    "collections": "",
    "signature": false,
    "lat": 41.672871,
    "lng": -70.924338
  },
  {
    "id": "loc_3jrneee3",
    "name": "BABY BOUDOIR OUTLET",
    "address1": "1902 ACUSHNET AVE",
    "address2": "",
    "city": "NEW BEDFORD",
    "state": "Massachusetts",
    "postal": "02745",
    "country": "United States",
    "phone": "508-998-2166",
    "website": "",
    "email": "",
    "logo": "",
    "collections": "",
    "signature": false,
    "lat": 41.672871,
    "lng": -70.924338
  },
  {
    "id": "loc_3ervyvv4",
    "name": "BABY GO ROUND",
    "address1": "105 Lafayette Road",
    "address2": "",
    "city": "Hampton Falls",
    "state": "New Hampshire",
    "postal": "03844",
    "country": "United States",
    "phone": "603-926-2255",
    "website": "",
    "email": "",
    "logo": "https://babygoroundinc.com/cdn/shop/files/BGR_Logo.jpg?v=1613725115&width=600",
    "collections": "Uptown, Karisma",
    "signature": false,
    "lat": 42.91848847,
    "lng": -70.86206569
  },
  {
    "id": "loc_4pvymmk4",
    "name": "HIP BABY GEAR",
    "address1": "118 Washington St",
    "address2": "",
    "city": "Marblehead",
    "state": "Massachusetts",
    "postal": "01945",
    "country": "United States",
    "phone": "(781) 631-5556",
    "website": "",
    "email": "",
    "logo": "https://cdn.shoplightspeed.com/shops/607706/themes/15634/v/740329/assets/logo.png?20230511131332",
    "collections": "Uptown, Karisma, Ventianni",
    "signature": false,
    "lat": 42.50453143,
    "lng": -70.84926697
  },
  {
    "id": "loc_4we8vwx4",
    "name": "USA BABY - SAN JUAN",
    "address1": "210 CHARDON AVE",
    "address2": "STE 104",
    "city": "San Juan",
    "state": "SAN JUAN",
    "postal": "00918",
    "country": "Puerto Rico",
    "phone": "787-758-0636",
    "website": "",
    "email": "",
    "logo": "",
    "collections": "",
    "signature": false,
    "lat": 18.42385755,
    "lng": -66.06766759
  },
  {
    "id": "loc_3rxx8q8q",
    "name": "ADORABLE TOTS",
    "address1": "Green Mill, Wellith Lane",
    "address2": "",
    "city": "Rochdale",
    "state": "",
    "postal": "OL11 2LS",
    "country": "England",
    "phone": "01706 248 844",
    "website": "https://www.adorabletots.co.uk/",
    "email": "",
    "logo": "",
    "collections": "",
    "signature": false,
    "lat": 53.6025594,
    "lng": -2.1482449
  },
  {
    "id": "loc_39yye8gy",
    "name": "INSIDE JOB",
    "address1": "472 Larkshall Road",
    "address2": "Highams Park",
    "city": "London",
    "state": "",
    "postal": "E4 9HH",
    "country": "England",
    "phone": "",
    "website": "https://www.insidejob.ltd/",
    "email": "",
    "logo": "",
    "collections": "",
    "signature": false,
    "lat": 51.60867144,
    "lng": -0.00127221
  },
  {
    "id": "loc_3jzz8m7e",
    "name": "BOUTIQUE COCON D'AMOUR",
    "address1": "199 AVENUE PIERRE BROSSOLETTE",
    "address2": "",
    "city": "",
    "state": "PERREUX SUR MARNE",
    "postal": "94170",
    "country": "France",
    "phone": "",
    "website": "https://www.cocondamour.fr/",
    "email": "",
    "logo": "",
    "collections": "",
    "signature": false,
    "lat": 48.83438,
    "lng": 2.51458001
  },
  {
    "id": "loc_3gpp7jm7",
    "name": "COCON D'AMOUR",
    "address1": "59 RUE EUGENES DESCAMPS",
    "address2": "",
    "city": "LILLE",
    "state": "",
    "postal": "59160",
    "country": "France",
    "phone": "",
    "website": "https://www.cocondamour.fr/",
    "email": "",
    "logo": "",
    "collections": "",
    "signature": false,
    "lat": 50.64905998,
    "lng": 3.00682998
  },
  {
    "id": "loc_3eqqe2kv",
    "name": "LUXURY BABY KONKKE",
    "address1": "Dumortierlaan 111",
    "address2": "",
    "city": "Knokke-Heist",
    "state": "",
    "postal": "8300",
    "country": "Belgium",
    "phone": "",
    "website": "https://luxurybaby.be/",
    "email": "",
    "logo": "",
    "collections": "",
    "signature": false,
    "lat": 51.35213,
    "lng": 3.29230998
  },
  {
    "id": "loc_4ywwnjqv",
    "name": "EL ESTILO",
    "address1": "Zijdstraat 67",
    "address2": "",
    "city": "Aalsmeer",
    "state": "",
    "postal": "1431 EB",
    "country": "Netherlands",
    "phone": "+31619601709",
    "website": "https://www.elestilo.nl/",
    "email": "info@elestilo.nl",
    "logo": "",
    "collections": "",
    "signature": false,
    "lat": 52.0190409,
    "lng": 4.16618625
  },
  {
    "id": "loc_4n9mpyk5",
    "name": "Atelier De Brocante Opkamer",
    "address1": "Nijverheidstraat 8",
    "address2": "",
    "city": "Naaldwijk",
    "state": "Holland",
    "postal": "2671",
    "country": "Holland",
    "phone": "06- 50 9999 10",
    "website": "https://www.atelierdebrocanteopkamer.nl/",
    "email": "de.opkamer@hotmail.nl",
    "logo": "",
    "collections": "",
    "signature": false,
    "lat": 52.0008909,
    "lng": 4.20807976
  },
  {
    "id": "loc_32nnvgy9",
    "name": "BABY & CO",
    "address1": "Quellinstraat 48-50",
    "address2": "",
    "city": "Antwerpen",
    "state": "",
    "postal": "2018",
    "country": "Belgium",
    "phone": "",
    "website": "https://babyenco.b",
    "email": "",
    "logo": "",
    "collections": "",
    "signature": false,
    "lat": 51.21580002,
    "lng": 4.41566999
  },
  {
    "id": "loc_3qxxjvny",
    "name": "BABY DREAMS",
    "address1": "Kerkstraat 12",
    "address2": "",
    "city": "Zandvoort aan Zee",
    "state": "",
    "postal": "2042 JE",
    "country": "Netherlands",
    "phone": "",
    "website": "https://www.baby-dreams.nl",
    "email": "",
    "logo": "",
    "collections": "",
    "signature": false,
    "lat": 52.37213159,
    "lng": 4.52710295
  },
  {
    "id": "loc_3v55yn7m",
    "name": "T GOUDEN KOETSJE",
    "address1": "Bisschopsmolenstraat 40",
    "address2": "",
    "city": "Etten-Leur",
    "state": "",
    "postal": "4876 AP",
    "country": "Netherlands",
    "phone": "",
    "website": "https://www.facebook.com/tgoudenkoetsje/",
    "email": "",
    "logo": "",
    "collections": "",
    "signature": false,
    "lat": 51.56741943,
    "lng": 4.63523931
  },
  {
    "id": "loc_4wggp29x",
    "name": "POPPEDOLL",
    "address1": "Behind Het Verguld Harnas 33",
    "address2": "",
    "city": "'s Hertogenbosch",
    "state": "",
    "postal": "5211 HL",
    "country": "Netherlands",
    "phone": "",
    "website": "https://www.poppedoll.nl/",
    "email": "",
    "logo": "",
    "collections": "",
    "signature": false,
    "lat": 51.68742113,
    "lng": 5.30253687
  },
  {
    "id": "loc_4p77e9wk",
    "name": "MAM & MIE",
    "address1": "Buskesdries 6",
    "address2": "",
    "city": "Andelst",
    "state": "",
    "postal": "6673 DP",
    "country": "Netherlands",
    "phone": "",
    "website": "https://www.mam-mie.nl/",
    "email": "",
    "logo": "",
    "collections": "",
    "signature": false,
    "lat": 51.91473369,
    "lng": 5.71639443
  },
  {
    "id": "loc_48gg2826",
    "name": "KINDER RAEUME",
    "address1": "Hohestr. 28",
    "address2": "",
    "city": "Düsseldorf",
    "state": "",
    "postal": "40213",
    "country": "Germany",
    "phone": "0211 8681563",
    "website": "https://www.kinderraeume.com/",
    "email": "",
    "logo": "",
    "collections": "",
    "signature": false,
    "lat": 51.22117001,
    "lng": 6.77426001
  },
  {
    "id": "loc_3mggwkqv",
    "name": "LA CASA DEL BEBE",
    "address1": "Piazza del Carmine 16b",
    "address2": "",
    "city": "Napoli",
    "state": "",
    "postal": "80133",
    "country": "Italy",
    "phone": "",
    "website": "https://www.lacasadelbebe.it/",
    "email": "",
    "logo": "",
    "collections": "",
    "signature": false,
    "lat": 40.84664042,
    "lng": 14.26694376
  },
  {
    "id": "loc_3xggwev6",
    "name": "BABY & CO HU",
    "address1": "Ipar utca 2/b",
    "address2": "",
    "city": "Budapest",
    "state": "",
    "postal": "1095",
    "country": "Hungary",
    "phone": "",
    "website": "http://www.baby.hu/",
    "email": "",
    "logo": "",
    "collections": "",
    "signature": false,
    "lat": 47.47825001,
    "lng": 19.07019002
  },
  {
    "id": "loc_45zzpxnn",
    "name": "BABY ISLAND",
    "address1": "Louvari 3",
    "address2": "",
    "city": "Peristeri",
    "state": "",
    "postal": "121 32",
    "country": "Greece",
    "phone": "",
    "website": "https://www.palibaby.gr/",
    "email": "",
    "logo": "",
    "collections": "",
    "signature": false,
    "lat": 38.00493,
    "lng": 23.70877003
  },
  {
    "id": "loc_3xjxqm63",
    "name": "Romina Furniture - Fabrica si Showroom",
    "address1": "1 Fabrica de Mobila",
    "address2": "",
    "city": "Bâldana",
    "state": "",
    "postal": "137436",
    "country": "Romania",
    "phone": "+1 980-585-1460",
    "website": "https://rominafurniture.com",
    "email": "contact@rominafurniture.com",
    "logo": "",
    "collections": "",
    "signature": false,
    "lat": 44.60628816,
    "lng": 25.77763509
  }
];

  function esc(value) {
    return String(value || "").replace(/[&<>"']/g, function (char) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[char];
    });
  }

  function cssUrl(value) {
    return String(value || "").replace(/["'\\)]/g, "");
  }

  function milesBetween(a, b) {
    var earth = 3958.8;
    var toRad = Math.PI / 180;
    var dLat = (b.lat - a.lat) * toRad;
    var dLng = (b.lng - a.lng) * toRad;
    var lat1 = a.lat * toRad;
    var lat2 = b.lat * toRad;
    var h =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(lat1) * Math.cos(lat2) * Math.sin(dLng / 2) * Math.sin(dLng / 2);
    return 2 * earth * Math.asin(Math.min(1, Math.sqrt(h)));
  }

  function line(store) {
    return [store.address1, store.address2].filter(Boolean).join(", ");
  }

  function cityLine(store) {
    return [store.city, store.state, store.postal].filter(Boolean).join(", ");
  }

  function href(url) {
    if (!url) return "";
    if (/^https?:\/\//i.test(url)) return url;
    return "https://" + url.replace(/^\/+/, "");
  }

  function parseJsonScript(id) {
    var el = document.getElementById(id);
    if (!el) return [];
    try {
      var data = JSON.parse(el.textContent || "[]");
      return Array.isArray(data) ? data : [];
    } catch (err) {
      return [];
    }
  }

  function normalize(store, index) {
    if (!store) return null;
    var lat = Number(store.lat);
    var lng = Number(store.lng);
    if (!isFinite(lat) || !isFinite(lng)) return null;
    return {
      id: String(store.id || "extra-" + index),
      name: store.name || "Store",
      address1: store.address1 || "",
      address2: store.address2 || "",
      city: store.city || "",
      state: store.state || "",
      postal: store.postal || "",
      country: store.country || "",
      phone: store.phone || "",
      website: store.website || "",
      logo: store.logo || "",
      signature: !!store.signature,
      lat: lat,
      lng: lng,
    };
  }

  function initLocator(root) {
    if (!root || root.dataset.rmlReady) return;
    var token = root.getAttribute("data-token") || "";
    if (!token || typeof mapboxgl === "undefined") return;
    root.dataset.rmlReady = "true";

    mapboxgl.accessToken = token;
    var radius = Number(root.getAttribute("data-radius") || 150);
    var style = root.getAttribute("data-style") || "mapbox://styles/mapbox/light-v11";
    var storesUrl = root.getAttribute("data-stores-url") || "";
    var extras = parseJsonScript(root.getAttribute("data-extras-id")).map(normalize).filter(Boolean);
    var builtin = parseJsonScript(root.getAttribute("data-stores-id"));
    if (!builtin.length) builtin = BUILTIN_STORES;
    var form = root.querySelector("[data-rml-form]");
    var input = root.querySelector("[data-rml-query]");
    var signatureOnly = root.querySelector("[data-rml-signature]");
    var list = root.querySelector("[data-rml-list]");
    var empty = root.querySelector("[data-rml-empty]");
    var status = root.querySelector("[data-rml-status]");
    var locateBtn = root.querySelector("[data-rml-locate]");
    var geotarget = root.getAttribute("data-geotarget") !== "false";
    var mapEl = root.querySelector("[data-rml-map]");
    var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    var allStores = extras.slice();
    var origin = null;
    var geoOrigin = null;
    var userPinned = false;
    var searchMiss = false;
    var markers = [];
    var map = new mapboxgl.Map({
      container: mapEl,
      style: style,
      center: [-87.65, 41.85],
      zoom: 3.4,
      attributionControl: true,
      cooperativeGestures: true,
    });
    map.addControl(new mapboxgl.NavigationControl({ showCompass: false }), "bottom-right");
    map.on("load", function () {
      map.resize();
    });
    if (typeof ResizeObserver !== "undefined") {
      new ResizeObserver(function () {
        map.resize();
      }).observe(mapEl);
    }

    function isCoarsePlace(value) {
      return /^(united states|usa|us|america|canada|north america)$/i.test(String(value || "").trim());
    }

    function compareStores(a, b) {
      if (!!a.signature !== !!b.signature) return a.signature ? -1 : 1;
      if (a.distance != null && b.distance != null && a.distance !== b.distance) {
        return a.distance - b.distance;
      }
      return a.name.localeCompare(b.name);
    }

    function visibleStores() {
      if (searchMiss) return [];
      var rows = allStores.slice();
      if (signatureOnly && signatureOnly.checked) {
        rows = rows.filter(function (store) {
          return store.signature;
        });
      }
      if (origin && !origin.coarse) {
        rows = rows
          .map(function (store) {
            var copy = Object.assign({}, store);
            copy.distance = milesBetween(origin, { lat: store.lat, lng: store.lng });
            return copy;
          })
          .filter(function (store) {
            return store.distance <= radius;
          });
      }
      rows.sort(compareStores);
      return rows;
    }

    function pinElement(store) {
      var el = document.createElement("button");
      el.type = "button";
      el.className = "rml-pin" + (store.signature ? " rml-pin--sig" : "") + (store.logo ? " rml-pin--logo" : "");
      el.setAttribute("aria-label", store.name);
      if (store.logo) {
        var img = document.createElement("span");
        img.className = "rml-pin__logo";
        img.style.backgroundImage = "url(\"" + cssUrl(store.logo) + "\")";
        el.appendChild(img);
      }
      return el;
    }

    function isHomeRegion(store) {
      return /united states|usa|canada|puerto rico/i.test(store.country || "");
    }

    function fit(rows) {
      var mapRows = origin ? rows : rows.filter(isHomeRegion);
      if (!mapRows.length) mapRows = rows;
      if (!mapRows.length) {
        if (origin) map.jumpTo({ center: [origin.lng, origin.lat], zoom: 8 });
        return;
      }
      var bounds = new mapboxgl.LngLatBounds();
      mapRows.forEach(function (store) {
        bounds.extend([store.lng, store.lat]);
      });
      if (origin) bounds.extend([origin.lng, origin.lat]);
      map.fitBounds(bounds, {
        padding: 56,
        maxZoom: mapRows.length === 1 ? 11 : 8.5,
        duration: reduceMotion ? 0 : 700,
      });
    }

    function render(rows) {
      markers.forEach(function (marker) {
        marker.remove();
      });
      markers = [];
      list.innerHTML = "";
      var searched = !!origin;
      var none = (searched || searchMiss) && !rows.length;
      if (empty) {
        empty.hidden = !none;
        empty.setAttribute("aria-hidden", none ? "false" : "true");
      }
      if (status) {
        if (none) status.textContent = "No stores nearby.";
        else status.textContent = "";
      }
      if (none) return;

      function addMarker(store) {
        var marker = new mapboxgl.Marker({ element: pinElement(store), anchor: "bottom" })
          .setLngLat([store.lng, store.lat])
          .addTo(map);
        var wrap = marker.getElement().parentNode;
        if (wrap && wrap.style) wrap.style.zIndex = store.signature ? "3" : "1";
        marker.getElement().addEventListener("click", function () {
          select(store.id, true);
        });
        markers.push(marker);
      }

      rows
        .filter(function (store) {
          return !store.signature;
        })
        .forEach(addMarker);
      rows
        .filter(function (store) {
          return store.signature;
        })
        .forEach(addMarker);

      rows.forEach(function (store) {
        var card = document.createElement("button");
        card.type = "button";
        card.className = "rml-card" + (store.signature ? " rml-card--sig" : "");
        card.dataset.storeId = store.id;
        var logo = store.logo
          ? '<span class="rml-card__logo" style="background-image:url(\'' + cssUrl(store.logo) + "')\"></span>"
          : '<span class="rml-card__mark' + (store.signature ? " rml-card__mark--sig" : "") + '" aria-hidden="true"></span>';
        var miles =
          store.distance != null
            ? '<span class="rml-card__miles">' + store.distance.toFixed(1) + " mi</span>"
            : "";
        var phone = store.phone
          ? '<a class="rml-card__phone" href="tel:' + esc(store.phone.replace(/[^\d+]/g, "")) + '">' + esc(store.phone) + "</a>"
          : "";
        var site = store.website
          ? '<a class="rml-card__web" href="' + esc(href(store.website)) + '" target="_blank" rel="noopener">Website</a>'
          : "";
        card.innerHTML =
          logo +
          '<span class="rml-card__body">' +
          '<span class="rml-card__name">' +
          esc(store.name) +
          "</span>" +
          '<span class="rml-card__addr">' +
          esc(line(store)) +
          "<br>" +
          esc(cityLine(store)) +
          (store.country ? "<br>" + esc(store.country) : "") +
          "</span>" +
          (store.signature ? '<span class="rml-card__badge">Signature Partner</span>' : "") +
          '<span class="rml-card__meta">' +
          miles +
          phone +
          site +
          "</span></span>";
        card.addEventListener("click", function (event) {
          if (event.target.closest("a")) return;
          select(store.id, true);
        });
        list.appendChild(card);
      });
    }

    function select(id, fly) {
      root.querySelectorAll(".rml-card").forEach(function (card) {
        card.classList.toggle("is-active", card.dataset.storeId === id);
      });
      var store = allStores.find(function (item) {
        return item.id === id;
      });
      if (store && fly) {
        map.flyTo({
          center: [store.lng, store.lat],
          zoom: 11,
          duration: reduceMotion ? 0 : 800,
        });
      }
      var active = list.querySelector(".rml-card.is-active");
      if (active) {
        active.scrollIntoView({ block: "nearest", behavior: reduceMotion ? "auto" : "smooth" });
      }
    }

    function refresh() {
      var rows = visibleStores();
      render(rows);
      fit(rows);
    }

    function setOrigin(point, label) {
      origin = point;
      searchMiss = false;
      if (label && input && !input.value) input.value = label;
      refresh();
    }

    function reverseLabel(point, done) {
      var url =
        "https://api.mapbox.com/geocoding/v5/mapbox.places/" +
        encodeURIComponent(point.lng + "," + point.lat) +
        ".json?limit=1&types=place,locality,postcode&access_token=" +
        encodeURIComponent(token);
      fetch(url)
        .then(function (res) {
          return res.json();
        })
        .then(function (data) {
          var feature = (data.features || [])[0];
          done(feature && feature.place_name ? feature.place_name.split(",")[0] : "");
        })
        .catch(function () {
          done("");
        });
    }

    function locateByGps() {
      if (!navigator.geolocation) return;
      navigator.geolocation.getCurrentPosition(
        function (pos) {
          var point = { lat: pos.coords.latitude, lng: pos.coords.longitude };
          geoOrigin = point;
          reverseLabel(point, function (label) {
            if (label && input) input.value = label;
            setOrigin(point, "");
          });
        },
        function () {},
        { enableHighAccuracy: false, timeout: 8000, maximumAge: 300000 }
      );
    }

    function locateByIp() {
      function apply(lat, lng, label, coarse) {
        if (userPinned) return;
        lat = Number(lat);
        lng = Number(lng);
        if (!isFinite(lat) || !isFinite(lng)) return;
        var point = { lat: lat, lng: lng, coarse: !!coarse };
        geoOrigin = point;
        if (coarse) {
          origin = null;
          refresh();
          return;
        }
        setOrigin(point, label || "");
      }

      function placeLabel(parts) {
        var seen = {};
        return parts.filter(function (part) {
          var key = String(part || "").trim().toLowerCase();
          if (!key || seen[key] || isCoarsePlace(part)) return false;
          seen[key] = true;
          return true;
        }).join(", ");
      }

      function isCoarseGeo(data) {
        if (!data) return true;
        var city = String(data.city || "").trim();
        var accuracy = String(data.accuracy || "").toLowerCase();
        if (!city || isCoarsePlace(city) || isCoarsePlace(data.region) || isCoarsePlace(data.country)) return true;
        if (accuracy === "country" || accuracy === "continent") return true;
        return false;
      }

      function fromGeoJs(data) {
        if (!data || data.latitude == null || data.longitude == null) return false;
        apply(data.latitude, data.longitude, placeLabel([data.city, data.region]), isCoarseGeo(data));
        return true;
      }

      function fromIpApi(data) {
        if (!data || data.error || data.latitude == null) return false;
        apply(data.latitude, data.longitude, placeLabel([data.city, data.postal || data.region_code]), isCoarseGeo(data));
        return true;
      }

      function fromIpWho(data) {
        if (!data || data.success === false || data.latitude == null) return false;
        apply(data.latitude, data.longitude, placeLabel([data.city, data.postal || data.region_code]), isCoarseGeo(data));
        return true;
      }

      fetch("https://get.geojs.io/v1/ip/geo.json")
        .then(function (res) {
          return res.json();
        })
        .then(function (data) {
          if (fromGeoJs(data)) return;
          return fetch("https://ipapi.co/json/")
            .then(function (res) {
              return res.json();
            })
            .then(function (fallback) {
              if (fromIpApi(fallback)) return;
              return fetch("https://ipwho.is/").then(function (res) {
                return res.json();
              }).then(fromIpWho);
            });
        })
        .catch(function () {
          fetch("https://ipapi.co/json/")
            .then(function (res) {
              return res.json();
            })
            .then(fromIpApi)
            .catch(function () {});
        });
    }

    function search(query) {
      var q = (query || "").trim();
      if (!q) {
        userPinned = false;
        searchMiss = false;
        origin = geoOrigin;
        refresh();
        return;
      }
      userPinned = true;
      var url =
        "https://api.mapbox.com/geocoding/v5/mapbox.places/" +
        encodeURIComponent(q) +
        ".json?limit=1&types=postcode,place,locality,address,region&access_token=" +
        encodeURIComponent(token);
      fetch(url)
        .then(function (res) {
          return res.json();
        })
        .then(function (data) {
          var feature = (data.features || [])[0];
          if (!feature) {
            origin = null;
            searchMiss = true;
            refresh();
            return;
          }
          var types = feature.place_type || [];
          var coarse = types.indexOf("country") !== -1 || (types.indexOf("region") !== -1 && isCoarsePlace(feature.text));
          origin = {
            lng: feature.center[0],
            lat: feature.center[1],
            coarse: coarse || isCoarsePlace(q)
          };
          searchMiss = false;
          refresh();
        })
        .catch(function () {
          origin = geoOrigin;
          searchMiss = false;
          refresh();
        });
    }

    form.addEventListener("submit", function (event) {
      event.preventDefault();
      search(input.value);
    });
    if (locateBtn) {
      locateBtn.addEventListener("click", function () {
        locateByGps();
      });
    }
    if (signatureOnly) signatureOnly.addEventListener("change", refresh);

    function start(base) {
      var source = base && base.length ? base : builtin;
      allStores = source.concat(extras).map(normalize).filter(Boolean);
      refresh();
      if (geotarget && !root.dataset.rmlGeo) {
        root.dataset.rmlGeo = "1";
        locateByIp();
      }
    }

    start([]);
    if (storesUrl) {
      fetch(storesUrl)
        .then(function (res) {
          if (!res.ok) throw new Error("stores");
          return res.json();
        })
        .then(function (data) {
          if (Array.isArray(data) && data.length) start(data);
        })
        .catch(function () {});
    }

    root._rmlDestroy = function () {
      markers.forEach(function (marker) {
        marker.remove();
      });
      map.remove();
      delete root.dataset.rmlReady;
    };
  }

  function boot(scope) {
    (scope || document).querySelectorAll("[data-romina-locator]").forEach(initLocator);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      boot();
    });
  } else {
    boot();
  }

  document.addEventListener("shopify:section:load", function (event) {
    boot(event.target);
  });
  document.addEventListener("shopify:section:unload", function (event) {
    var root = event.target.querySelector("[data-romina-locator]");
    if (root && typeof root._rmlDestroy === "function") root._rmlDestroy();
  });
})();
